<template>
  <div>
    <div class="bg-white relative h-full">
      <div class="w-full">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-responsive table-flush cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-color"
        >
          <el-table-column prop="city" label="Field Name" min-width="50px">
            <template slot-scope="">
              <P class="text-gray">First Name</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Variable" min-width="50px">
            <template slot-scope="">
              <P class="text-gray">%%firstname%%</P>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination background layout="prev, pager, next" :total="1000">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      input: "",
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
